























































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import {
  DocuSignTemplateModel,
  BaseResultModel,
  DocuSignTemplateConfigurationModel,
  ArenaSignTemplateCreateUpdateModel,
  Configuration
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';

export default Vue.extend({
  name: 'DocusignAddTemplate',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: true,
      docuSignTemplate: {} as ArenaSignTemplateCreateUpdateModel,
      docuSignTemplateConfigurationModel: {} as DocuSignTemplateConfigurationModel,
      submitIsLoading: false,
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (isValid) {
          this.submitIsLoading = true;

          const result: BaseResultModel = await DocuSignConfigurationService.createTemplateAsync({
            documentTypeId: this.documentTypeId,
            template: this.docuSignTemplate.template
          } as ArenaSignTemplateCreateUpdateModel);

          if (result.hasNotification && !result.showToast) {
            this.addFormValidationError(result.notification);
            this.submitIsLoading = false;
            return;
          }

          SnotifyConfiguration.showSuccess('Template created successfully.');
          this.setApplicationDirty(false);
          this.navigateToTemplateTabManagement();
        }
      } catch (error) {
        this.$log('Error creating template', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getDataAsync(this: any) {
      this.isLoading = true;
      try {
        this.docuSignTemplateConfigurationModel = await DocuSignConfigurationService.getTemplateConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateId: null
        });
      } catch (error) {
        this.$log('Error getting template');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToTemplateTabManagement();
    },
    navigateToTemplateTabManagement(this: any) {
      this.navigateToRoute(Configuration.DocuSign.Template.Management.name, this.documentTypeId);
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    }
  },
  mounted(this: any) {
    this.getDataAsync();
  },
  components: {
    LoadingSpinner,
    MStoreTable
  }
});
